var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (_, features, filterPlans, planKey, plans) {var plan = plans.findByPlanKey(planKey)
var index = _.findIndex(plans.models, { plan: planKey })
var prevPlan = index && _.at(plans.models, index - 1)[0];
var prevPlanIndex = index && index - 1;
var currentFeatures = features.filter(function (feature) {
  var featureAvailableForPlans = feature.plans.filter(filterPlans).length;
  var isNotInPreviousPlans = (plans.length - index) === featureAvailableForPlans;
  var isNotFiltered = plan.hasFeature(feature);
  return isNotInPreviousPlans && isNotFiltered;
});
var prevPlanFeatures = prevPlan && features.filter(function (feature) {
  var featureAvailableForPlans = feature.plans.filter(filterPlans).length;
  var isNotInPreviousPlans = (plans.length - prevPlanIndex) === featureAvailableForPlans;
  var isNotFiltered = prevPlan.hasFeature(feature);
  return isNotInPreviousPlans && isNotFiltered;
});
var prevPlanFeaturesArray = prevPlan && _.map(prevPlanFeatures.models).map(function (f) {
  return f.friendlyName
})
var freeFeatures = [
  'Passwordless',
  'Lock for Web, iOS & Android',
  'Up to 2 social identity providers',
  'Unlimited Serverless Rules'
];

var planFreeFeatures = [
  {friendlyName: 'Passwordless', link:'https://auth0.com/passwordless', description: "An alternative to using username / password credentials to authenticate a user. Currently supported: one-time passwords delivered by email or SMS message, one-click links delivered by email, or positive identification using Apple's Touch ID APIs on IOS devices."},
  {friendlyName: 'Lock for Web, iOS & Android', link:'https://auth0.com/lock', description:'A native "login box" user interface for web applications, single-page applications, iOS, Android & Windows Phones (among others) using popular frameworks. Lock is an intuitive, easy and attractive authentication widget that can be styled to reflect your brand, and that supports all the user-accessible capabilities of Auth0 without additional coding.'},
  {friendlyName: 'Up to 2 social identity providers', link:'https://auth0.com/docs/identityproviders', description:'IdPs, typically using OAuth2 or OpenID Connect, that allow third parties to authenticate users using their credentials.  Auth0 supports every popular social site, e.g. such as Facebook, Twitter, LinkedIn, and GitHub, and can work with any IdP compatible with OAuth2 or OIDC.'},
  {friendlyName: 'Unlimited Serverless Rules', link:'https://auth0.com/docs/rules/current', description:'Custom Javascript snippets that run in a secure, isolated sandbox in the Auth0 service as part of your authentication pipeline - limited only by your imagination.'}
];

pug_mixins["check-icon"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Csvg class=\"check-icon-white\" width=\"12px\" height=\"9px\" viewBox=\"423 363 12 9\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\"\u003E\n\u003Cpolygon id=\"Path-2\" stroke=\"none\" fill=\"#FFFFFF\" fill-rule=\"evenodd\" points=\"426.355216 371.158394 427.068452 371.87163 427.775506 371.152265 434.41029 364.401955 432.983923 363 426.349139 369.750309 427.769429 369.74418 424.414214 366.388964 423 367.803178\"\u003E\u003C\u002Fpolygon\u003E\n\u003C\u002Fsvg\u003E";
};
pug_mixins["prev-plan-mixin"] = pug_interp = function(plan, features){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E" + (pug.escape(null == (pug_interp = 'also includes:') ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
if ('free' === plan.plan) {
// iterate freeFeatures
;(function(){
  var $$obj = freeFeatures;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var feature = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E";
pug_mixins["check-icon"]();
pug_html = pug_html + (pug.escape(null == (pug_interp = feature) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E";
pug_mixins["check-icon"]();
pug_html = pug_html + (pug.escape(null == (pug_interp = feature) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

}
else {
// iterate features
;(function(){
  var $$obj = features;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var feature = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E";
pug_mixins["check-icon"]();
pug_html = pug_html + (pug.escape(null == (pug_interp = feature) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E";
pug_mixins["check-icon"]();
pug_html = pug_html + (pug.escape(null == (pug_interp = feature) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

}
};
pug_mixins["feature-item"] = pug_interp = function(title, feature){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cp" + (" class=\"only-tooltip\""+" data-toggle=\"tooltip\" data-placement=\"bottom\" data-container=\"body\" data-trigger=\"hover\""+pug.attr("data-original-title", feature.description, true, true)) + "\u003E";
if (feature.link) {
pug_html = pug_html + "\u003Ca" + (" class=\"feature-link\""+pug.attr("href", feature.link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fp\u003E";
};
pug_mixins["plan-features"] = pug_interp = function(plan, prevPlan){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var logFeature = plan.planFeatures.findByFeatureKey('logs');
var logFeatureTitle = logFeature.getDescription() + ' of ' + logFeature.feature.friendlyName
var socialConnFeature = plan.planFeatures.findByFeatureKey('social_connections');
var socialConnFeatureTitle = (socialConnFeature.getDescription() ||  'Unlimited') + ' Social Identity Providers'
var enterpriseConnFeature = plan.planFeatures.findByFeatureKey('enterprise_connections');
var enterpriseConnFeatureTitle = enterpriseConnFeature && (enterpriseConnFeature.getDescription() ||  'Unlimited') + ' Enterprise Identity Providers';
const planId = plan.plan;

pug_html = pug_html + "\u003Cul class=\"feature-list\"\u003E";
if ((planId === 'free')) {
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E" + (pug.escape(null == (pug_interp = 'All Free Features Below:') ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
}
if (prevPlan) {
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E" + (pug.escape(null == (pug_interp = 'All ' + prevPlan.name + ' Features') ? "" : pug_interp)) + "\u003Cul class=\"feature-sublist\"\u003E";
pug_mixins["prev-plan-mixin"](prevPlan, prevPlanFeaturesArray);
pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fli\u003E";
}
if (enterpriseConnFeature && (planId === 'developer-pro')) {
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E";
pug_mixins["feature-item"](enterpriseConnFeatureTitle, enterpriseConnFeature.feature);
pug_html = pug_html + "\u003C\u002Fli\u003E";
}
if ((planId !== 'free')) {
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E";
pug_mixins["feature-item"](logFeatureTitle, logFeature.feature);
pug_html = pug_html + "\u003C\u002Fli\u003E\u003Cli class=\"feature\"\u003E";
pug_mixins["feature-item"](socialConnFeatureTitle, socialConnFeature.feature);
pug_html = pug_html + "\u003C\u002Fli\u003E";
}
if (enterpriseConnFeature && (planId !== 'developer-pro')) {
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E";
pug_mixins["feature-item"](enterpriseConnFeatureTitle, enterpriseConnFeature.feature);
pug_html = pug_html + "\u003C\u002Fli\u003E";
}
if ((planId !== 'free')) {
// iterate currentFeatures.models
;(function(){
  var $$obj = currentFeatures.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var feature = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E";
pug_mixins["feature-item"](feature.friendlyName, feature);
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E";
pug_mixins["feature-item"](feature.friendlyName, feature);
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

}
if ((planId === 'free')) {
// iterate planFreeFeatures
;(function(){
  var $$obj = planFreeFeatures;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var feature = $$obj[pug_index3];
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E";
pug_mixins["feature-item"](feature.friendlyName, feature);
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index3];
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E";
pug_mixins["feature-item"](feature.friendlyName, feature);
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003C\u002Ful\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"plan-features\"\u003E";
pug_mixins["plan-features"](plan, prevPlan);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";}.call(this,"_" in locals_for_with?locals_for_with._:typeof _!=="undefined"?_:undefined,"features" in locals_for_with?locals_for_with.features:typeof features!=="undefined"?features:undefined,"filterPlans" in locals_for_with?locals_for_with.filterPlans:typeof filterPlans!=="undefined"?filterPlans:undefined,"planKey" in locals_for_with?locals_for_with.planKey:typeof planKey!=="undefined"?planKey:undefined,"plans" in locals_for_with?locals_for_with.plans:typeof plans!=="undefined"?plans:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/ab-variants/new-pricing/partials/features/feature-widget.pug
// module id = 1164
// module chunks = 0